export default "__VITE_ASSET__BIFgfE8I__"